<template>
  <div id="app" :class="{ 'dark-mode': isDarkMode }">
    <Header :mainHeader="true" v-if="showHeader" />
    <router-view />
  </div>
</template>

<script>

import { darkModeState } from './composables/useDarkMode'
import Header from './components/Header.vue'

export default {
  name: 'App',
  components: {
    Header
  },
  computed: {
    isDarkMode() {
      return darkModeState.isDarkMode
    },
    isAuthPage() {
      // Hide header on auth pages (e.g., login, register, forgot-password)
      const authRoutes = ['/', '/login', '/auth', '/auth/login', ];
      // Hide header for auth pages or routes explicitly marked public
      return authRoutes.includes(this.$route.path) || this.$route.path.startsWith('/auth') || !!this.$route.meta?.public;
    }
    ,
    showHeader() {
      const authRoutes = ['/', '/login', '/auth', '/auth/login'];
      return !(authRoutes.includes(this.$route.path) || this.$route.path.startsWith('/auth') || !!this.$route.meta?.public || this.$route.path.includes('pdf'));
    }
  },
  meta:{
    title: 'Default Title',
    titleTemplate: '%s | My Awesome Webapp'
  }
}
</script>

<style>
@import './assets/css/dark-mode.css';

#app {
  min-height: 100vh;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Override for HTML and body to ensure full page coverage */
html, body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background-color: var(--bg-primary);
  color: var(--text-primary);
}
</style>
